import { memo, useMemo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { createChildAppOnNavigate } from 'modules/app-registry/utils'
import { useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'

import { FullPageAppTemplate } from '../../templates'

export const TemplateManagerApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const history = useHistory()
    const { user } = useUserContext()
    const { apps } = useAvailableApps()
    // Window mode emits basename-stripped paths (`/workspace`); prefix them
    // with the app path so the container doesn't leave `/template-manager`.
    const onNavigate = useMemo(
      () =>
        createChildAppOnNavigate(apps[AppId.TEMPLATE_MANAGER].path, navigate),
      [apps, navigate]
    )

    return (
      <FullPageAppTemplate
        appId={AppId.TEMPLATE_MANAGER}
        scope='template_manager'
        envKey={apps[AppId.TEMPLATE_MANAGER].runtimeEnvKey}
        entryPath='./TemplateManagerApp'
        url={process.env.REACT_APP_TEMPLATE_MANAGER_APP_DEV_PATH}
        appName={apps[AppId.TEMPLATE_MANAGER].name}
        appProps={{
          user,
          history: history,
          appPath: apps[AppId.TEMPLATE_MANAGER].path,
          initialPath: location.pathname,
          onNavigate
        }}
      />
    )
  },
  // when there are no props, this is OK to use. without this comparison function, we will have higher memory usage
  () => true
)
